/* eslint-disable prettier/prettier */
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

function AppLoader({ size = 28, color = "#dc2626" }) {
  const cellSize = Math.max(6, Math.round(size * 0.32));
  const gap = Math.max(4, Math.round(size * 0.18));
  const radius = Math.max(2, Math.round(cellSize * 0.2));

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(2, ${cellSize}px)`,
        gap: `${gap}px`,
        color,
        "@keyframes appLoaderPulse": {
          "0%, 100%": { opacity: 0.25, transform: "scale(0.9)" },
          "25%": { opacity: 1, transform: "scale(1)" },
          "50%": { opacity: 0.45, transform: "scale(0.92)" },
          "75%": { opacity: 0.25, transform: "scale(0.9)" },
        },
      }}
    >
      {[0, 1, 2, 3].map((square) => (
        <Box
          key={square}
          sx={{
            width: cellSize,
            height: cellSize,
            borderRadius: radius,
            bgcolor: "currentColor",
            animation: "appLoaderPulse 1.1s infinite ease-in-out",
            animationDelay: `${square * 0.2}s`,
          }}
        />
      ))}
    </Box>
  );
}

AppLoader.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default AppLoader;
